import { Button } from "@kobalte/core";
import { styled } from "solid-styled-components";

export const ModeButtonWrapper = styled(Button.Root)`
  width: 40%;
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  background: ${({ theme }) => theme?.input?.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
